import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { MtrwcService,  } from '../_service_mtr';
import { Mtrwc } from '../_entity_mtr';
import { JkRichEditorComponent } from 'jk-service';


@Component({
  selector: 'app-mtrwc-edit',
  templateUrl: './mtrwc-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, AdvComModule, MaterialModule, JkRichEditorComponent],
})

export class MtrwcEditComponent extends JkDialogEditComponent<MtrwcService, Mtrwc> {
  override srv!: MtrwcService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrwcEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject, dialogRef, data);
  }

  getImagePath(item: Mtrwc): string {
    return item.WC001 + '-' + item.WC002 || 'unknown';
  }

}
